import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AnyObject } from "yup";

const initialState: AnyObject = {
  email: "",
  roleCodeDetails: null,
};

const emailAuth = createSlice({
  name: "emailAuth",
  initialState,
  reducers: {
    setEmail(state, action: PayloadAction<AnyObject>) {
      state.email = action.payload;
    },
    setRoleCodeDetails(state, action: PayloadAction<AnyObject>) {
      state.roleCodeDetails = action.payload;
    },
  },
});

export const { setEmail, setRoleCodeDetails } = emailAuth.actions;
export default emailAuth.reducer;
